export enum TimeRange {
    eTimeRangeUserdefined = 0,
    eTimeRangeToday,
    eTimeRangeThisWeek,
    eTimeRangeThisMonth,
    eTimeRangeThisQuartar,
    eTimeRangeThisHalfYear,
    eTimeRangeThisYear,
    eTimeRangeActWJahr,
    eTimeRangeLast7Days,
    eTimeRangeLast14Days,
    eTimeRangeLastMonth,
    eTimeRangeLast3Months,
    eTimeRangeLast6Months,
    eTimeRangeLastQuartar,
    eTimeRangeLastHalfYear,
    eTimeRangeLastYear,
    eTimeRangeLastWJahr,
    eTimeRangeJanuary,
    eTimeRangeFebruary,
    eTimeRangeMarch,
    eTimeRangeApril,
    eTimeRangeMay,
    eTimeRangeJune,
    eTimeRangeJuly,
    eTimeRangeAugust,
    eTimeRangeSeptember,
    eTimeRangeOctober,
    eTimeRangeNovember,
    eTimeRangeDecember,
    eTimeRangeNextMonth,
    eTimeRangeActWQuartar,
    eTimeRangeActWHalfYear,
    eTimeRangeWLastQuartar,
    eTimeRangeWLastHalfYear,
    eTimeRangeThisMonthTodayMinus15,
    eTimeRangeThisYearMonthUltimo,
    eTimeRangeActWJahrMonthUltimo,
    eTimeRange2MonthAgo,
    eTimeRangeLast,
}

export const timeRangeToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in TimeRange) {
        const label = TimeRange[x as keyof typeof TimeRange]
        opts.push({
            name: t(`global:enum.TimeRange.${label}`),
            value: TimeRange[x as keyof typeof TimeRange],
        })
    }

    return opts
}
